import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { PurchasePassFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkPurchasePassPOSTErrorResponse, ParkPurchasePassPOSTRequest, ParkPurchasePassPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchPurchasePass = async (data: ParkPurchasePassPOSTRequest): Promise<ParkPurchasePassPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPurchasePassPOSTSuccessResponse>("/purchase-pass", data);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkPurchasePassPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PurchasePassFailReason };
  }
};
